import React from 'react';
import dynamic from 'next/dynamic';

const France = dynamic(() => import('./france'));
const Germany = dynamic(() => import('./germany'));
const Italy = dynamic(() => import('./italy'));
const Netherlands = dynamic(() => import('./netherlands'));
const Portugal = dynamic(() => import('./portugal'));
const Spain = dynamic(() => import('./spain'));
const Sweden = dynamic(() => import('./sweden'));
const UnitedKingdom = dynamic(() => import('./united-kingdom'));
const UnitedStates = dynamic(() => import('./united-states'));
const Australia = dynamic(() => import('./australia'));
const Austria = dynamic(() => import('./austria'));
const Belgium = dynamic(() => import('./belgium'));
const CzechReplublic = dynamic(() => import('./czech-republic'));
const Denmark = dynamic(() => import('./denmark'));
const Finland = dynamic(() => import('./finland'));
const Hungary = dynamic(() => import('./hungary'));
const Iceland = dynamic(() => import('./iceland'));
const Ireland = dynamic(() => import('./ireland'));
const Luxembourg = dynamic(() => import('./luxembourg'));
const NewZealand = dynamic(() => import('./new-zealand'));
const Poland = dynamic(() => import('./poland'));
const Slovakia = dynamic(() => import('./slovakia'));
const Switzerland = dynamic(() => import('./switzerland'));

type Props = {
  flagName: string;
  className?: string;
};

const Icon: React.FC<Props> = ({ className, flagName }: Props) => {
  const iconClassNames = `h-14 w-21 ${className}`;
  const flags = {
    FR: <France className={iconClassNames} />,
    DE: <Germany className={iconClassNames} />,
    IT: <Italy className={iconClassNames} />,
    NL: <Netherlands className={iconClassNames} />,
    PT: <Portugal className={iconClassNames} />,
    ES: <Spain className={iconClassNames} />,
    SE: <Sweden className={iconClassNames} />,
    GB: <UnitedKingdom className={iconClassNames} />,
    US: <UnitedStates className={iconClassNames} />,
    AU: <Australia className={iconClassNames} />,
    AT: <Austria className={iconClassNames} />,
    BE: <Belgium className={iconClassNames} />,
    CZ: <CzechReplublic className={iconClassNames} />,
    DK: <Denmark className={iconClassNames} />,
    FI: <Finland className={iconClassNames} />,
    HU: <Hungary className={iconClassNames} />,
    IS: <Iceland className={iconClassNames} />,
    IE: <Ireland className={iconClassNames} />,
    LU: <Luxembourg className={iconClassNames} />,
    PL: <Poland className={iconClassNames} />,
    SK: <Slovakia className={iconClassNames} />,
    CH: <Switzerland className={iconClassNames} />,
  };
  return <>{flags[flagName as keyof typeof flags]}</>;
};

export default Icon;
